import React, { useMemo } from 'react';
import { MeetingContainerContext } from './context';
import { MeetingContainer } from '@kalyzee/kast-web-sdk';
import { MeetingContainerContextState } from './interfaces';

export type MeetingContainerProviderProps = {
  container: MeetingContainer;
  children: React.ReactNode;
};

export const MeetingContainerProvider: React.FC<MeetingContainerProviderProps> = ({
  container,
  children,
}) => {
  const state = useMemo<MeetingContainerContextState>(() => ({
    container,
    containerAPI: container.getAPI(),
  }), [container]);
  return (
    <MeetingContainerContext.Provider value={state}>
      {children}
    </MeetingContainerContext.Provider>
  );
};
